import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';

@Component({
  selector: 'app-risk-ressessment-machine-list',
  templateUrl: './risk-ressessment-machine-list.component.html',
  styleUrls: ['./risk-ressessment-machine-list.component.scss'],
})
export class RiskRessessmentMachineListComponent implements OnInit {
  selectedMachines: any[];
  isAnyValueChanged: boolean;
  constructor( public sharedValue: ShareValuesService,
    public modalController: ModalController,
    public backendService: BackendCallService) { }
  @Input() selectedProductId: any;
  @Input() data: any;
  getProjectServiceTypeLoading: boolean;
  ngOnInit() {
    this.getProjectServiceTypeLoading = true;
    this.backendService.getRiskResssesmentMachinebyServiceId(this.data.id)
    .subscribe(
      (data: any) => {
        data.forEach(element => {
          element.isChecked=false;
        });
        this.selectedMachines = data;
        this.getProjectServiceTypeLoading = false;
      },
      (err) => {
        this.getProjectServiceTypeLoading = false;
      }
    );
  }

  changeRoadmapCheckedValue() {
    this.isAnyValueChanged = this.selectedMachines.some(_pr => _pr.isChecked);
  }

  close() {
    this.modalController.dismiss({});
  }

  saveSelectedMachineInfo(){
    this.modalController.dismiss({selectedMachines:this.selectedMachines});
  }

}
